<template lang="html">
  <section class="demo">

    <div style="width: 100%; display: flex; flex-direction: column">
      <h4>Chat Screen</h4>

      <div style="display: flex; flex-direction: row;">

        <div style="display: flex; flex: 1; flex-direction: column; justify-content: space-around">

          <div>
            Clicking on one of the existing chat or clicking on an App User Contact in the New Conversation screen will
            bring you to the Chat Screen.
          </div>

          <div style="margin-top: 16px;">
            <div style="margin-bottom: 16px;">In this screen, you can:</div>

            <ul class="Vlt-list Vlt-list--simple">
              <li>send a text message to the user by using the textbox and the send button at the bottom</li>
              <li>call the user by clicking the phone icon at the top right corner</li>
            </ul>
          </div>

          <div>
            <span style="font-style: italic; color: #ff0000;">
              Note: Attachments are not supported at the moment. There are some bugs in the application, rendering the
              attachment feature to be not working. We will update again once this feature is available.
            </span>
          </div>

        </div>

        <div>
          <img src="https://vids.vonage.com/pages/inapp-android/image10.jpg" width="240" alt="image10" />
        </div>

      </div>

      <h5>Calling an App User</h5>

      <div style="display: flex; flex-direction: row;">

        <div style="display: flex; flex: 1; flex-direction: column; justify-content: space-around">

          <div style="margin-top: 16px;">
            <div style="margin-bottom: 16px;">Clicking on the phone button in the Chat Screen will present you with a
              call dialog, which you can choose to call the user via:</div>

            <ul class="Vlt-list Vlt-list--simple">
              <li>In-App call</li>
              <li>External call (PSTN or SIP)</li>
            </ul>
          </div>

        </div>

        <div>
          <img src="https://vids.vonage.com/pages/inapp-android/image11.jpg" width="240" alt="image11" />
        </div>

      </div>

    </div>

  </section>

</template>

<script lang="js">
export default {
  name: 'demo',
  components: {
  },
  props: {
    nexmo: {
      type: Object,
      required: false
    }
  },
}
</script>

<style scoped lang="scss"></style>